<template>
    <!-- Carte item (fond gris clair comme l’exemple, séparateur bas blanc) -->
    <div class="block bg-[#EDF2F7] relative">
        <section class="px-1 py-2 pt-4">
            <!-- Bouton Edit rond en haut à droite -->
            <router-link :to="linkDetenteur"
                class="absolute top-2 right-2 bg-primary rounded-full h-9 w-9 flex items-center justify-center"
                aria-label="Modifier le détenteur">
                <i class="inline-block h-6 w-6 mask mask-edit bg-white"></i>
            </router-link>

            <!-- En-tête : icône type + raison sociale + code client -->
            <div class="flex items-center flex-wrap gap-2">
                <i v-if="detenteur.type === 'Société'" class="inline-block h-5 w-5 mask mask-building bg-primary"></i>
                <i v-else-if="detenteur.type === 'Particulier'"
                    class="inline-block h-5 w-5 mask mask-user bg-primary"></i>
                <i v-else-if="detenteur.type === 'Association'"
                    class="inline-block h-5 w-5 mask mask-assos bg-primary"></i>

                <h2 class="text-xl text-bleu-moyen">
                    <span class="font-bold">{{ detenteur.raison_sociale }}</span>
                </h2>

                <p v-if="detenteur.code_client" class="text-md text-secondary">- {{ detenteur.code_client }}</p>
            </div>

            <!-- Adresse -->
            <p class="text-md text-gris mt-1">
                {{ detenteur.adresse }}<br />
                {{ detenteur.code_postal }} {{ detenteur.ville }}
            </p>

            <!-- Téléphones + Trackdechets -->
            <div class="flex items-start justify-between gap-3 mt-3">
                <!-- Col numéros + nom contact -->
                <div class="flex flex-col md:flex-row gap-1">
                    <a v-if="detenteur.telephone"
                        class="inline-flex items-center px-2 py-2 bg-primary text-white font-semibold rounded-lg shadow text-md"
                        :href="linkTel">
                        <i class="inline-block h-6 w-6 mask mask-home bg-white mr-2"></i>
                        <span class="text-[clamp(0.8rem,2vw,1.1rem)]">{{ detenteur.telephone }}</span>
                    </a>

                    <p v-if="detenteur.nom" class="text-md text-gris md:self-center md:mx-2">{{ detenteur.nom }}</p>

                    <a v-if="detenteur.portable"
                        class="inline-flex items-center px-2 py-2 bg-primary text-white font-semibold rounded-lg shadow text-md"
                        :href="linkMobile">
                        <i class="inline-block h-6 w-6 mask mask-phone bg-white mr-2"></i>
                        <span class="text-[clamp(0.8rem,2vw,1.1rem)]">{{ detenteur.portable }}</span>
                    </a>
                </div>

                <!-- Bloc Trackdéchets -->
                <div class="flex items-center gap-2 group relative">
                    <!-- Logo à gauche si OK / Particulier / etc. -->
                    <div v-if="tdShowLogo" class="relative">
                        <img :src="urlTD" alt="TrackDéchets" class="h-10 w-auto" />
                    </div>
                    <!-- Status à droite -->
                    <div class="flex flex-col gap-1 text-center">
                        <span v-if="tdNonConforme"
                            class="text-[clamp(0.9rem,2vw,1rem)] font-medium text-alert leading-tight">
                            Non conforme<br />TrackDéchets
                        </span>

                        <span v-else-if="tdOk"
                            class="text-[clamp(0.9rem,2vw,1rem)] font-medium text-vert leading-tight">
                            OK TrackDéchets
                        </span>

                        <span v-if="tdSiretAVerifier"
                            class="text-[clamp(0.9rem,2vw,1rem)] font-medium text-orange leading-tight">
                            SIRET à vérifier
                        </span>

                        <span v-if="tdNonInscrit"
                            class="text-[clamp(0.9rem,2vw,1rem)] font-medium text-orange leading-tight">
                            Non inscrit
                        </span>

                        <span v-if="tdCodePostalAVerifier"
                            class="text-[clamp(0.9rem,2vw,1rem)] font-medium text-orange leading-tight">
                            Code postal à vérifier
                        </span>

                        <span v-if="detenteur.type === 'Particulier'"
                            class="text-[clamp(0.9rem,2vw,1rem)] font-medium text-secondary leading-tight">
                            Particulier
                        </span>
                    </div>
                </div>
            </div>

            <!-- Ligne Installations + Goto -->
            <div class="flex justify-between items-center mt-3">
                <router-link :to="linkInstallations"
                    class="inline-flex items-center uppercase gap-3 pl-8 px-4 py-3 rounded-r-full bg-secondary text-white text-md font-semibold -ml-4">
                    <i class="inline-block h-5 w-5 mask mask-industry bg-white"></i>
                    <span>Installations</span>
                </router-link>

                <div class="bg-primary rounded-full h-9 w-9 flex items-center justify-center mr-2 cursor-pointer"
                    @click="goToGPS(detenteur)">
                    <i class="inline-block h-6 w-6 mask mask-goto bg-white"></i>
                </div>
            </div>
        </section>

        <!-- séparateur blanc comme l’exemple -->
        <div class="h-4 bg-white"></div>
    </div>
</template>

<script>
import Config from "../../js/config";

export default {
    props: {
        detenteur: { type: Object, required: true },
        typeuser: { default: null }
    },

    data() {
        return {
            urlTD: Config.urlAdmin + '/img/trackdechets.png'
        }
    },

    computed: {
        // ----- LOGIQUE TRACKDÉCHETS -----
        tdOk() {
            const v = Number(this.detenteur.is_registered_on_track_dechets);
            // même logique que ton exemple Vite :
            // OK si 3/10/20/1 ou Particulier
            return (
                v === 3 || v === 10 || v === 20 || v === 1 || this.detenteur.type === 'Particulier'
            );
        },
        tdNonConforme() {
            const v = Number(this.detenteur.is_registered_on_track_dechets);
            return (this.detenteur.type === 'Société') && (this.detenteur.siret == null || v === 0);
        },
        tdSiretAVerifier() {
            const v = Number(this.detenteur.is_registered_on_track_dechets);
            return (this.detenteur.type === 'Société') && v === 10;
        },
        tdNonInscrit() {
            return Number(this.detenteur.is_registered_on_track_dechets) === 1;
        },
        tdCodePostalAVerifier() {
            return Number(this.detenteur.is_registered_on_track_dechets) === 2;
        },
        tdShowLogo() {
            const v = Number(this.detenteur.is_registered_on_track_dechets);
            // idem à ton JS vite: affiche le logo quand "okTrackDechets" est vrai
            // (inclut 1 = NON INSCRIT) OU particulier OU 20
            return this.tdOk || this.tdNonInscrit || this.detenteur.type === 'Particulier' || v === 20;
        },

        // ----- LIENS / ROUTES -----
        linkDetenteur() {
            return 'detenteur/' + this.detenteur.id;
        },
        linkInstallations() {
            return this.linkDetenteur + '/installations/';
        },
        linkTel() {
            return 'tel:' + this.detenteur.telephone;
        },
        linkMobile() {
            return 'tel:' + this.detenteur.portable;
        }
    },

    methods: {
        goToGPS(detenteur) {
            if (!detenteur) return;

            const address =
                detenteur.adresse +
                (detenteur.complement_adresse ? ' ' + detenteur.complement_adresse : '') +
                ' ' + detenteur.code_postal + ' ' + detenteur.ville;

            const lat = detenteur.lat;
            const lng = detenteur.lng;

            if (lat && lng && address) {
                swal({
                    title: "Enregistrer la localisation",
                    text: "Voulez vous suivre l'adresse du détenteur ou sa position ?",
                    type: "question",
                    confirmButtonText: "Adresse",
                    cancelButtonText: "Position",
                    showCancelButton: true,
                }).then((result) => {
                    if (window.isMobile()) {
                        if (typeof window.flutter_inappwebview !== 'undefined' && window.flutter_inappwebview !== null) {
                            if (result === true) {
                                window.flutter_inappwebview.callHandler('goTo', 'address', address);
                            }
                        }
                    }
                }, (result) => {
                    if (window.isMobile()) {
                        if (typeof window.flutter_inappwebview !== 'undefined' && window.flutter_inappwebview !== null) {
                            if (result === 'cancel') {
                                window.flutter_inappwebview.callHandler('goTo', 'latlng', lat, lng, detenteur.raison_sociale);
                            }
                        }
                    }
                });
            } else {
                if (window.isMobile()) {
                    if (typeof window.flutter_inappwebview !== 'undefined' && window.flutter_inappwebview !== null) {
                        window.flutter_inappwebview.callHandler('goTo', 'address', address);
                    }
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// DetenteurItem.vue?2cbe0fca